module.exports = __webpack_public_path__ + "img/1.a8696931.png";